/**
 * Centralized user-name display helper.
 *
 * Prefers `user.name` when it's a real human name.
 * Falls back to a prettified email local part only when name is missing or
 * is itself just the email's local part (legacy seed data).
 */
export function userDisplayName(user) {
  if (!user) return "Unassigned";
  const name = (user.name || "").trim();
  const email = user.email || "";
  const local = email.split("@")[0] || "";

  const norm = (s) => (s || "").toLowerCase().replace(/[.\s_\-]+/g, "");
  const nameNorm = norm(name);
  const localNorm = norm(local);

  // Real human name present and different from email → use it
  if (name && nameNorm !== localNorm && name !== email) return name;

  // Otherwise prettify the email local part: "caller.sampoorna" → "Caller Sampoorna"
  if (local) {
    return local
      .replace(/[._-]+/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase())
      .trim();
  }
  return name || email || "Unassigned";
}

/** True if the name needs admin cleanup (empty or looks email-derived). */
export function userNameIsOrphan(user) {
  if (!user) return false;
  const name = (user.name || "").trim();
  const email = user.email || "";
  const local = email.split("@")[0] || "";
  if (!name) return true;
  const norm = (s) => (s || "").toLowerCase().replace(/[.\s_\-]+/g, "");
  return norm(name) === norm(local) || name === email;
}
